module.exports = __webpack_public_path__ + "media/tutorial-1.svg";